import { Box } from '@mui/material';
import CircularIndeterminate from 'components/blocks/progressBar/progressBar';
import ContentNormal from 'components/elements/ContentNormal';
import Headline3 from 'components/elements/Headline3';
import SectionWrapper from 'components/layouts/SectionWrapper';
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { callAPI } from "utils/API";
import { useInterval } from 'utils/useInterval';

export const PaymentSessionHandler = () => {
    const navigate = useNavigate();
    const { ChargeID } = useParams();

    const handlePaymentSession = async () => {
        const handlePaymentResponse = await callAPI(`/charge/${ChargeID}/status`, "GET");
        if (handlePaymentResponse && (handlePaymentResponse.status === 'AUTHORIZED' || handlePaymentResponse.status === 'SETTLED')) {
            switch (handlePaymentResponse.relatedType) {
                case "CONFIRMATION":
                    return navigate(`/order-confirmation/${handlePaymentResponse.relatedId}`)
                case "CONFIRMATION_DELIVERY":
                    return navigate(`/order-confirmation/${handlePaymentResponse.relatedId}`)
                case "WALLET":
                    return navigate(`/wallet-confirmation/${handlePaymentResponse.relatedId}`)
                default:
                    break;
            }
        } else if (handlePaymentResponse.status === 'PENDING') {
            // Do nothing, awaiting payment
        } else {
            navigate(`/payment-error/${ChargeID}`)
        }
    }

    useInterval(() => {
        handlePaymentSession()
    }, 1000 * 3)

    return (
        <SectionWrapper sx={{minHeight: '60vh'}}>
            <Box sx={{paddingTop: 14}} display={'flex'} flexDirection={'column'} gap={4} alignItems={'center'}>
                <Box display={'flex'} gap={4}>
                    <Headline3
                        translationKey="_PAYMENT_PENDING_TITLE_"
                        fallbackText="Tak for dit køb"
                    />
                </Box>
                <ContentNormal
                    translationKey="_PAYMENT_PENDING_DESCRIPTION_"
                    fallbackText="Afventer bekræftelse på betaling..."
                />

                <CircularIndeterminate />
            </Box>
        </SectionWrapper>
    )
}
